import { UPCOMING_MATCHES, FULL_SCHEDULE } from "../constants/routes";
import localStorageService from './localStorageService';
import api from '../utils/api';

class UpcomingMatchesService {
    private controller: AbortController | null = null;

    // Fetch upcoming matches
  public getUpcomingMatches = async (teamCode: number , sportCode: string) => {
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || '';

    const controller = new AbortController(); // local controller
    const payload = { team_code: teamCode, sport_code: sportCode };

    try {
        const response = await api.post(UPCOMING_MATCHES, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            signal: controller.signal,
        });

        return response.data;
    } catch (error: any) {
            console.error("Error fetching upcoming matches:", error);
            throw error;            
    }
};


    public getFullSchedule = async (teamCode: number, season: string, sport_code: string) => {
    const userInfo = localStorageService.getUserInfo();
    const token = userInfo?.access_token || '';

    const controller = new AbortController(); // local controller
    const payload = { team_code: teamCode, season, sport_code: sport_code };

    try {
        const response = await api.post(FULL_SCHEDULE, payload, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            signal: controller.signal,
        });

        return response.data;
    } catch (error: any) {
    console.error("Error fetching  scehedule:", error);
    throw error;    
    }
};

}

export default UpcomingMatchesService;
